import { Image } from '@mantine/core';

const CustomLogo = ( { logo, alt }: { logo: string, alt: string } ) => (
	<div className="VeryBusyLogo">
		<Image className="logo" src={logo} width={240} height={60} fit="contain" alt={alt} />
	</div>
);

export default CustomLogo;
